module.exports = __webpack_public_path__ + "img/icoon_kampvuur_small.54e62b25.svg";